import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useCountryService from '../../../app/services/hooks/useCountryService';
import { CountryDataForm, defaultCountryDataForm } from '../../../app/models/Country';
import CountryForm from './forms/CountryForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

interface Props {
    countryId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const CountryEdit = ({ countryId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { editCountry, updateCountry, fetchingEditCountry, fetchingUpdateCountry } = useCountryService();
    const [country, setCountry] = useState<CountryDataForm>(defaultCountryDataForm);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando país...');
        editCountry(countryId, {
            onSuccess: (response: ServiceResponse) => {
                setCountry(response.data.country);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    }, [countryId]);

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando país...');
        updateCountry(countryId, country, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({ title: 'Éxito', message: response.message });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({ title: 'Error', message: response.message });
                if (onError) onError();
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    if (fetchingEditCountry) return <LazyLoading height={300} />;

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <CountryForm country={country} setCountry={setCountry} errorFields={errorFields} />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={() => onCancel?.()} locked={fetchingUpdateCountry} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} locked={fetchingUpdateCountry} />
                </div>
            </div>
        </>
    );
};

export default CountryEdit;
